module.exports = __webpack_public_path__ + "static/media/sair.b809b553.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/svg/sair.svg
// module id = 1287
// module chunks = 0